'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propEnhancers = exports.propValidators = exports.propAliases = exports.propTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getCss = require('../get-css');

var _getCss2 = _interopRequireDefault(_getCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
  transition: _propTypes2.default.string,
  transitionDelay: _propTypes2.default.string,
  transitionDuration: _propTypes2.default.string,
  transitionProperty: _propTypes2.default.string,
  transitionTimingFunction: _propTypes2.default.string
};

var propAliases = exports.propAliases = {};

var propValidators = exports.propValidators = {};

var _transition = {
  className: 'tstn',
  cssName: 'transition',
  jsName: 'transition',
  complexValue: true
};
var _transitionDelay = {
  className: 'tstn-dly',
  cssName: 'transition-delay',
  jsName: 'transitionDelay',
  complexValue: true
};
var _transitionDuration = {
  className: 'tstn-drn',
  cssName: 'transition-duration',
  jsName: 'transitionDuration',
  complexValue: true
};
var _transitionProperty = {
  className: 'tstn-pty',
  cssName: 'transition-property',
  jsName: 'transitionProperty',
  complexValue: true
};
var _transitionTimingFunction = {
  className: 'tstn-tf',
  cssName: 'transition-timing-function',
  jsName: 'transitionTimingFunction',
  complexValue: true
};

var propEnhancers = exports.propEnhancers = {
  transition: function transition(value) {
    return (0, _getCss2.default)(_transition, value);
  },
  transitionDelay: function transitionDelay(value) {
    return (0, _getCss2.default)(_transitionDelay, value);
  },
  transitionDuration: function transitionDuration(value) {
    return (0, _getCss2.default)(_transitionDuration, value);
  },
  transitionProperty: function transitionProperty(value) {
    return (0, _getCss2.default)(_transitionProperty, value);
  },
  transitionTimingFunction: function transitionTimingFunction(value) {
    return (0, _getCss2.default)(_transitionTimingFunction, value);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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